import { getCycles } from './GetCycles';
import { getCycleById } from './GetCycleById';
import { createCycle } from './CreateCycle';
import { updateCycle } from './UpdateCycle';
import { getCycleMemberships } from './GetCycleMemberships';
import { updateMembershipStatus } from './UpdateMembershipStatus';
import { uploadMembershipsCsv } from './UploadMembershipsCsv';
import { downloadCycleExport } from './DownloadCycleExport';

export const AwardsService = {
  getCycles,
  getCycleById,
  createCycle,
  updateCycle,
  getCycleMemberships,
  updateMembershipStatus,
  uploadMembershipsCsv,
  downloadCycleExport,
};
